const REQUIRED_RULE_MESSAGE = 'This field is required'

export const requiredRule = { required: { value: true, message: REQUIRED_RULE_MESSAGE } }
export const numberRule = { valueAsNumber: true }
export const requiredAndNumberRules = { ...requiredRule, ...numberRule }
export const positiveRule = {
  positive: value => (parseInt(value) > 0 ? true : 'This field must be bigger than 0'),
}
